import { render, staticRenderFns } from "./zXDetail.vue?vue&type=template&id=794da88f&scoped=true&"
import script from "./zXDetail.vue?vue&type=script&setup=true&lang=js&"
export * from "./zXDetail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./zXDetail.vue?vue&type=style&index=0&id=794da88f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794da88f",
  null
  
)

export default component.exports